import { render, staticRenderFns } from "./customer-rate.vue?vue&type=template&id=fe886032&"
import script from "./customer-rate.vue?vue&type=script&lang=js&"
export * from "./customer-rate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports